module.exports = __webpack_public_path__ + "img/AT0000001342797.fd25d987.png";